module.exports = __webpack_public_path__ + "static/media/zelle.5f56c0dd.png";